import { render, staticRenderFns } from "./AnchorageStages.vue?vue&type=template&id=6ae05eb8&"
import script from "./AnchorageStages.vue?vue&type=script&lang=js&"
export * from "./AnchorageStages.vue?vue&type=script&lang=js&"
import style0 from "./AnchorageStages.vue?vue&type=style&index=0&id=6ae05eb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports